import { useLocation } from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { addHomeImage } from "../../actions/HomePageImages";
import { useNavigate } from "react-router-dom";

import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";

interface LocationState {
  user?: any;
}

function AddHomeImage() {
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const location = useLocation();
  const state = location.state as LocationState;
  const user = state?.user;

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

  const [title, setTitle] = useState<string>('');
  const [link, setLink] = useState<string>('');
  const [mainImage, setMainImage] = useState<File | null>(null);
  const [mobileImage, setMobileImage] = useState<File | null>(null);
  const [mainImageError, setMainImageError] = useState<string>('');
  const [mobileImageError, setMobileImageError] = useState<string>('');
  const [mainPreviewUrl, setMainPreviewUrl] = useState<string>('');
  const [mobilePreviewUrl, setMobilePreviewUrl] = useState<string>('');
  const [submitMessage, setSubmitMessage] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const validateImage = (file: File): string | null => {
    const validTypes = ['image/jpeg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      return 'Only JPG or PNG files are allowed.';
    }
    if (file.size > 5 * 1024 * 1024) {
      return 'File size must be less than or equal to 5MB.';
    }
    return null;
  };

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>, type: 'main' | 'mobile') => {
    const file = e.target.files?.[0];
    if (file) {
      const error = validateImage(file);
      if (error) {
        if (type === 'main') {
          setMainImageError(error);
          setMainImage(null);
          setMainPreviewUrl('');
        } else {
          setMobileImageError(error);
          setMobileImage(null);
          setMobilePreviewUrl('');
        }
        return;
      }

      const url = URL.createObjectURL(file);
      if (type === 'main') {
        setMainImage(file);
        setMainImageError('');
        setMainPreviewUrl(url);
      } else {
        setMobileImage(file);
        setMobileImageError('');
        setMobilePreviewUrl(url);
      }
    }
  };

  const removeImage = (type: 'main' | 'mobile') => {
    if (type === 'main') {
      setMainImage(null);
      setMainPreviewUrl('');
      setMainImageError('');
    } else {
      setMobileImage(null);
      setMobilePreviewUrl('');
      setMobileImageError('');
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!title || !link || !mainImage || !mobileImage) {
      setSubmitMessage('Please fill in all fields and select both images.');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      await addHomeImage({ title, link, image: mainImage, mobileImage }); // Send both images
      navigate('/dashboard/home/images', { state: { user } })

    } catch (error) {
      setSubmitMessage('An error occurred while adding the image.');
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Cleanup preview URLs
  useEffect(() => {
    return () => {
      if (mainPreviewUrl) URL.revokeObjectURL(mainPreviewUrl);
      if (mobilePreviewUrl) URL.revokeObjectURL(mobilePreviewUrl);
    };
  }, [mainPreviewUrl, mobilePreviewUrl]);

  return (
    <div>
      <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
      <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

      <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
        <div className='main-admin-page-inner'>
          <form onSubmit={handleSubmit}>
            <h2>Add New Home Page Image</h2>

            <div className="content-form-field">
              <input
                type="text"
                className="input-email"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>

            <div className="content-form-field">
              <input
                type="text"
                className="input-email"
                placeholder="Link"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                required
              />
            </div>

            {/* Main Image Upload */}
            <div className="content-form-field">
              <br /><label>Main Image</label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, 'main')}
                style={{ marginTop: '10px' }}
              />
              {mainImageError && <div style={{ color: 'red' }}>{mainImageError}</div>}
              {mainPreviewUrl && (
                <div style={{ marginTop: '10px' }}>
                  <strong>Preview</strong><br />
                  <img src={mainPreviewUrl} alt="Main Preview" style={{ maxWidth: '100%', maxHeight: '300px' }} />
                  <br />
                  <button type="button" onClick={() => removeImage('main')}>Remove Image</button>
                </div>
              )}
            </div>

            {/* Mobile Image Upload */}
            <div className="content-form-field">
              <br /><label>Mobile Image</label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, 'mobile')}
                style={{ marginTop: '10px' }}
              />
              {mobileImageError && <div style={{ color: 'red' }}>{mobileImageError}</div>}
              {mobilePreviewUrl && (
                <div style={{ marginTop: '10px' }}>
                  <strong>Preview</strong><br />
                  <img src={mobilePreviewUrl} alt="Mobile Preview" style={{ maxWidth: '100%', maxHeight: '300px' }} />
                  <br />
                  <button type="button" onClick={() => removeImage('mobile')}>Remove Image</button>
                </div>
              )}
            </div>
            <br />

            <div className="content-form-button">
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Save Changes'}
              </button>
            </div>

            {submitMessage && (
              <div style={{ marginTop: '10px', color: submitMessage.includes('successfully') ? 'green' : 'red' }}>
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddHomeImage;
